module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// /home/jenkins/agent/workspace/b-apps_b2c-site_b2c-site_develop/node_modules/babel-runtime/regenerator/index.js
// module id = 73
// module chunks = 81